import React from 'react';
import { INITIAL_SUGGESTIONS_URL,MS_LOCATION } from '../../constants/constants';
import '../../assets/css/search.css';
import Suggestions from './Suggestions';

export default class ContactUsSearch extends React.Component {

    constructor(props) {
        super(props);
        this.autoCompleteRef = React.createRef();
        this.inputRef = React.createRef();
        this.state = {
        // searchURL: "https://www.verizon.com/onesearch/search?q=call&ES=ResidentialSupport&src=home",
        // query: '',
            results: [],
            homequicklinks:[]
        // defaultLinks: []
        };
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleSearchClickOutside = this.handleSearchClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleSearchClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleSearchClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleSearchClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        this.autoCompleteRef.current.parentElement.classList.remove('focused');
    }
  }

  componentWillUnmount() {
    }
    
    onSearchBoxFocus(e) {
        //window.scLinkTrackID11('support_search');
        let domain = window.location.origin.indexOf("www.verizon.com") > -1 ? "https://www.verizon.com" : "https://www98.verizon.com";
        if (this.inputRef.current.value.length <= 2) {
            const localInstance = this;
            if (this.inputRef.current.value.length <= 2) {
                this.inputRef.current.parentElement.parentElement.classList.remove('auto_suggestions');
            }
            // fetch(domain + "/search/AutoSuggest/headersearch/?Ntt=&action=GET_QUICK_LINKS&segments=ResidentialSupport&ES=ResidentialSupport")
            //     .then((response) => {
            //         return response.text();
            //     })
            //     .then((TextContent) => {
            //         localInstance.autoCompleteRef.current.parentElement.classList.add('focused');
            //         localInstance.autoCompleteRef.current.innerHTML = TextContent;
            //     });
            var quicklinksdata =[] ;        
            quicklinksdata = JSON.stringify(window.homePageData.quicklinks[0].quicklinklist);
            var quicklinklist = JSON.parse(quicklinksdata);
            this.setState({
                homequicklinks: quicklinklist
            });
            this.setState({
                results: null
            });
            localInstance.autoCompleteRef.current.parentElement.classList.add('focused');
        } else if(this.inputRef.current.value.length > 2) {
            this.autoCompleteRef.current.parentElement.classList.add('focused');
        }
    }

    onSearchBoxBlur(e) {
        let localInstance = this;
        setTimeout(() => {
            localInstance.autoCompleteRef.current.parentElement.classList.remove('focused');
        }, 200);
       // this.autoCompleteRef.current.innerHTML = '';
    }

    searchValue() {
        //window.scLinkTrackID('search_'+ this.inputRef.current.value);
        this.sendSearchRequest(this.inputRef.current.value);
    }

    sendSearchRequest(searchText) {
        //window.scLinkTrackID('search_'+ searchText);
        if(searchText.length <= 2) {
            this.onSearchBoxFocus(null);
        } else {
            const localInstance = this;
            let autoSuggesturl = null;
            autoSuggesturl = MS_LOCATION + "/getAutoSuggestSearch";
            //autoSuggesturl="https://www.verizon.com/support/consumer/getAutoSuggestSearch";
            const reqData = {"searchText":searchText };

            fetch(autoSuggesturl, {
                method: "POST",
                headers: new Headers({
                    "content-type": "application/json"
                }),
                body: JSON.stringify(reqData)
            }).then(response => response.json())
            .then((data) => {
                let noToRestrict = 0;
                const links = [];
                if(data.typeAheadSummary.TypeAheadSuggestedTerms.length != 0){
                    data.typeAheadSummary.TypeAheadSuggestedTerms.map((result) => {
                        // condition to restrict number of results shown for Autosuggest option
                        if (noToRestrict < 5) {
                            noToRestrict++;
                            const link = {};
                            link.linkurl = result.href.indexOf('/onesearch') > 0 ? (`${result.href}&source=support&flow=support`) : result.href;
                            link.linktext = result.name;
                            links.push(link);
                        }
                    })
                // .catch((error) =>{
                //     console.log(error);
                // });

                this.setState({
                    results: links
                });
                
                this.setState({
                    homequicklinks: null
                });

                localInstance.autoCompleteRef.current.parentElement.classList.add('focused');
                // var quickLinkselement = document.getElementById('quickLinksId');
                // if (typeof(quickLinkselement) != 'undefined' && quickLinkselement != null)
                // {
                //     // Exists.
                //     quickLinkselement.parentNode.removeChild(quickLinkselement);
                // }
            }
            else if(data.typeAheadSummary.TypeAheadSuggestedTerms.length == 0){
                this.setState({
                    results: null
                });
                this.setState({
                    homequicklinks: null
                });
            }
            });
        }
    }

    searchEnteredText(e) {
        //window.scLinkTrackID('search_'+ e.target.value);     
        const keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
            if(e.target.value != "")
            {
                let domain = window.location.origin.indexOf("www.verizon.com") > -1 ? "https://www.verizon.com" : "https://www98.verizon.com";
                window.location.href = domain + "/onesearch/search?q=" + e.target.value + "&ES=ResidentialSupport&src=home";
            }
            else{
                alert("Please enter a search phrase");
            }
        } 
        else {
        // if (this.inputRef.current.value.length >= 3) {
                this.inputRef.current.parentElement.parentElement.classList.add('auto_suggestions');
                this.sendSearchRequest(e.target.value);
        // }
        }     
    }

    handleSearchKeyActions(e){
        //Focus trap inside modal overlay - keyboard accessibility fix
    
        var selection = document.querySelector('#auto_suggestdiv') !== null;
        if (selection) {
            const currentfocusedelement = document.activeElement;
            const  focusableElements = '[href], [tabindex]:not([tabindex="-1"])';
            const modal = document.querySelector('#auto_suggestdiv');
            const focusable = modal.querySelectorAll(focusableElements);
            const firstFocusable = focusable[0];
            const lastFocusable = focusable[focusable.length - 1];

            if (e.ctrlKey || e.altKey) {
                return;
            }

            const keys = {
                9: () => { //9 = TAB
                    if (e.shiftKey && e.target === firstFocusable) {
                        lastFocusable.focus();
                    }

                    if (e.target === lastFocusable) {
                        //firstFocusable.focus();
                       this.autoCompleteRef.current.parentElement.classList.remove('focused');
                    }
                },

                40: () => { //down arrow
                    for(var i=0; i<focusable.length; i++) { //loop through each element
                        if(focusable[i].innerText == currentfocusedelement.innerText) { //check the current active element
                            focusable[i+1].focus();
                            e.preventDefault();
                            break;
                        }
                    }
                },

                38: () => { //UP arrow
                    for(var i=0; i<focusable.length; i++) { //loop through each element
                        if(focusable[i].innerText == currentfocusedelement.innerText) { //check the current active element
                            focusable[i-1].focus();
                            e.preventDefault();
                            break;
                        }
                    }
                },

                27:()=>{ //hide search items div on pressing escape key
                    this.autoCompleteRef.current.parentElement.classList.remove('focused');
                }
            };

            if (keys[e.keyCode]) {
                keys[e.keyCode]();
            }
        }
    }


    render() {
        return (
            <div className="m_input-field" ref={this.setWrapperRef}>
                <label htmlFor="fooheader_search" className="field-icon icon-search text-grey-3" onClick={this.searchValue.bind(this)}>
                    <svg focusable="false" xmlns="http://www.w3.org/2000/svg" width="30" height={this.props.searchIconHeight} viewBox="0 0 18 18"><path fill="#959595" fillRule="nonzero" d="M17.896 17.101l-5.995-5.994A6.721 6.721 0 0 0 13.5 6.75a6.75 6.75 0 1 0-6.75 6.75c1.661 0 3.18-.603 4.356-1.598l5.995 5.995.795-.796zM6.75 12.375A5.63 5.63 0 0 1 1.125 6.75 5.63 5.63 0 0 1 6.75 1.125a5.63 5.63 0 0 1 5.625 5.625 5.63 5.63 0 0 1-5.625 5.625z"></path></svg>
                </label>
                <input ref={this.inputRef} type="text" aria-labelledby={this.props.AriaLabel} 
                placeholder={this.props.PlaceHolder} className="search-box margin-bottom-zero normal-weight" 
                tabIndex="0"               
                onKeyUp={this.searchEnteredText.bind(this)} 
                onFocus={this.onSearchBoxFocus.bind(this)}
                 />
                <div ref={this.autoCompleteRef} role="list" className="search-complete" 
                id="auto_suggestdiv"  onKeyDown={this.handleSearchKeyActions.bind(this)}>
                { 
                    (this.state.results !== null && this.state.results !== undefined && (this.state.results.length > 0)) ? 
                    <Suggestions results={this.state.results} /> : 
                    (this.state.homequicklinks !== null && this.state.homequicklinks !== undefined && (this.state.homequicklinks.length > 0)) ? 
                     <Suggestions results={this.state.homequicklinks} /> :
                     ""
                }
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modules/ContactUsSearch.js